import { Box, Pressable, Text } from '@rbilabs/universal-components';

export const TimeSelector = Pressable.withConfig<{ $isSelected?: boolean }>(props => ({
  borderBottomWidth: '1',
  borderBottomColor: 'token.border-color-default',
  mb: '$2',
  paddingY: '$2',
  width: 'full',
  opacity: props.$isSelected ? 1 : 0.4,
}));

export const MockedSelectorDate = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const MockedSelectorTime = Box.withConfig({});

export const MockedSelectorTitle = Text.withConfig({
  fontSize: 'xs',
  fontWeight: 'normal',
});

export const ActionButtonContainer = Box.withConfig({
  marginTop: '$6',
  width: 'full',
});
